module.exports = __webpack_public_path__ + "img/4.741ec5f8.png";